import { useContext } from "react";
import { DownloadContext } from "../../data_layer/context/Download/DownloadContext";
import { LoadingButton } from "../Loading/LoadingButton";

export const ExportAllFeedingsByFacilityZip = ({ facility, patients }) => {
    const { isDownloading, startDownload } = useContext(DownloadContext);

    const onButtonClick = (event) => {
        event.preventDefault();
        startDownload(facility, patients);
    };

    return (
        <LoadingButton
            title="Download All Feedings"
            onClick={onButtonClick}
            loading={isDownloading}
        />
    );
};
